import React from 'react';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <div className="container-xxl py-6 py-md-4 py-sm-3">
      <div className="container">
        <div className="row g-5 g-sm-4 g-md-5">
          {/* Images Section */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="row img-twice position-relative h-100 g-3 g-md-4">
              <div className="col-6 col-sm-6 col-md-6">
                <img 
                  className="img-fluid rounded w-100 h-auto" 
                  src="/img/img6.jpg" 
                  alt="About" 
                  style={{objectFit: 'cover', minHeight: '250px'}}
                />
              </div>
              <div className="col-6 col-sm-6 col-md-6 align-self-end">
                <img 
                  className="img-fluid rounded w-100 h-auto mt-3 mt-sm-0" 
                  src="/img/img7.jpg" 
                  alt="About" 
                  style={{objectFit: 'cover', minHeight: '250px'}}
                />
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="h-100">
              <p className="text-primarys text-uppercase mb-2 fs-6 fs-md-5">// About Us</p>
              <h1 className="display-6 mb-3 mb-md-4 fs-2 fs-md-1">Who We Are</h1>
              
              <div className="mb-3 mb-md-4">
                <p className="mb-2 mb-md-3 fs-6 fs-md-5 lh-base">
                  New Galaxy Interiors is a full-service design and build company delivering comprehensive solutions across interiors, fit-outs, installations, landscaping, and renovation works — seamlessly executed from concept to completion.
                </p>
                <p className="fs-6 fs-md-5 lh-base">
                 Our vision is to redefine integrated design and construction by creating enduring spaces through innovative design, precise execution, quality craftsmanship, and thoughtful environments that enhance everyday living.
                </p>
              </div>

              {/* Features List */}
              <div className="row g-2 mb-3 mb-md-4">
                <div className="col-12 col-sm-6 mb-2 mb-sm-0">
                  <div className="d-flex align-items-center">
                    <i className="fa fa-check text-primarys me-2 fs-6"></i>
                    <span className="fs-6 fs-sm-5">High-Quality Interior & Construction Materials</span>
                  </div>
                </div>
                <div className="col-12 col-sm-6 mb-2 mb-sm-0">
                  <div className="d-flex align-items-center">
                    <i className="fa fa-check text-primarys me-2 fs-6"></i>
                    <span className="fs-6 fs-sm-5">Design, Build & Fit-Out Expertise</span>
                  </div>
                </div>
                <div className="col-12 col-sm-6 mb-2 mb-sm-0">
                  <div className="d-flex align-items-center">
                    <i className="fa fa-check text-primarys me-2 fs-6"></i>
                    <span className="fs-6 fs-sm-5">Interior, Installation & Landscaping Services</span>
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="d-flex align-items-center">
                    <i className="fa fa-check text-primarys me-2 fs-6"></i>
                    <span className="fs-6 fs-sm-5">Reliable, On-Time Project Delivery</span>
                  </div>
                </div>
              </div>

              {/* Button */}
              <Link 
                to="/product" 
                className="btn btn-primarys rounded-pill py-2 py-md-3 px-4 px-md-5 fs-6 fs-md-5"
              >
                Read More
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;

